import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize, Observable, of, tap } from 'rxjs';
// import { SpinnerService } from './spinner.service'; // @todo - implement our own spinner
// import { ToastService } from './toast.service'; // @todo - @Ann, move toastr into it's own service that can be called from any component

const HTTP_OPTIONS = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class DataService {
  constructor(private http: HttpClient, private toastr: ToastrService) {}

  // will handle all get requests with optional message and optional options
  // in DRDP there were three methods to handle gets, going to combine them all here for now
  // we can default to our const here unless custom options are passed,
  // for example, download files option
  get(path: string, message?: string, options: any = HTTP_OPTIONS) {
    // show spinner, but we don't want to cover the entire website like in DRDP
    return this.http.get(path, options).pipe(
      tap(() => this.handleSuccess(message)),
      catchError((err: any) => this.handleError(err)),
      finalize(() => false)
    );
  }

  post(
    path: string,
    payload: any,
    message?: string,
    options?: any
  ): Observable<any> {
    // show spinner, but we don't want to cover the entire website like in DRDP
    return this.http.post(path, payload, options).pipe(
      tap(() => this.handleSuccess(message)),
      catchError((err: any) => this.handleError(err)),
      finalize(() => false)
    );
  }

  delete(path: string, message?: string): Observable<any> {
    // show spinner, but we don't want to cover the entire website like in DRDP
    return this.http.delete(path).pipe(
      tap(() => this.handleSuccess(message)),
      catchError((err: any) => this.handleError(err)),
      finalize(() => false)
    );
  }

  patch(path: string, payload: any, message?: string): Observable<any> {
    // show spinner, but we don't want to cover the entire website like in DRDP
    return this.http.patch(path, payload).pipe(
      tap(() => this.handleSuccess(message)),
      catchError((err: any) => this.handleError(err)),
      finalize(() => false)
    );
  }

  put(path: string, payload: unknown, message?: string): Observable<any> {
    // show spinner, but we don't want to cover the entire website like in DRDP
    return this.http.put(path, payload).pipe(
      tap(() => this.handleSuccess(message)),
      catchError((err: any) => this.handleError(err)),
      finalize(() => false)
    );
  }

  private handleError(err: HttpErrorResponse): Observable<any> {
    let message = 'Error, something went Wrong.';
    if (err.error) {
      message =
        err.error && typeof err.error === 'string'
          ? err.error
          : err.error.Message
          ? err.error.Message
          : err.message;
    }
    this.toastr.error(message)
    return of(false);
  }

  private handleSuccess(message?: string): void {
    if (message) {
      this.toastr.success(message)
    }
  }
}
